/**
 * Görsel tema yapılandırması.
 *
 * Uygulama üç temalıdır ve tema, kullanıcının bağlamından türetilir:
 * AuthService.getKullaniciTipi() hangi tipse <html> üzerine
 * data-pt-tema="<tip>" yazılır, CSS de rengi oradan alır.
 *
 * Renk değerleri burada DEĞİL, assets/sass/components/_tokens.scss içindeki
 * $pt-temalar haritasındadır — tek kaynak orası. Buradaki isimler o haritanın
 * anahtarlarıyla birebir aynı olmak zorunda.
 */

/** Kullanıcının çalıştığı bağlam. Hem varsayılan rotayı hem temayı belirler. */
export type KullaniciTipi = 'genel' | 'gundem' | 'firma';

/** Temanın <html> üzerine yazıldığı öznitelik. CSS tarafı: [data-pt-tema="..."]. */
export const TEMA_ATTR = 'data-pt-tema';

/** Kullanıcı tipi belirlenemediğinde geçerli olan tema. */
export const VARSAYILAN_TEMA: KullaniciTipi = 'genel';
